import { RecurringTypesEnum } from "dash-common";
import { Badge } from "dash-ui";
import { useTheme } from "styled-components";

// Define the types for the props
interface IRecurringTypeToggle {
  recurringType?: RecurringTypesEnum;
  onToggle: (newRecurringType: RecurringTypesEnum) => void;
  className?: string;
  activeColor?: string;
  inactiveColor?: string;
}

const RecurringTypeToggle: React.FC<IRecurringTypeToggle> = ({
  onToggle,
  recurringType,
  className = "",
  activeColor,
  inactiveColor,
}) => {
  const handleToggle = () => {
    const newRecurringType =
      recurringType === RecurringTypesEnum.MONTH
        ? RecurringTypesEnum.SIXMONTH
        : RecurringTypesEnum.MONTH;

    onToggle(newRecurringType);
  };

  const theme = useTheme();

  return (
    <div
      className={`relative w-60 h-12 flex items-center rounded-lg p-1 cursor-pointer border-sky-600 border ${className}`}
      style={{ backgroundColor: inactiveColor || theme.colors.white }}
      onClick={handleToggle}>
      {/* Background "pill" to highlight selected option */}
      <Badge
        title="Save up to 10%!"
        type="active"
        className="absolute text-center -top-4 -right-6 z-20"
      />
      <div
        className={`absolute top-0 bottom-0 left-0 w-1/2 rounded-lg border-white border-4 transition-transform duration-300 ${
          recurringType === RecurringTypesEnum.MONTH
            ? "transform translate-x-0"
            : "transform translate-x-full"
        }`}
        style={{ backgroundColor: activeColor || theme.colors.b50 }}></div>

      <span
        className={`flex-1 text-center z-10 transition-colors duration-300 ${
          recurringType === RecurringTypesEnum.MONTH
            ? "text-white"
            : "text-sky-600"
        }`}>
        Month
      </span>

      <span
        className={`flex-1 text-center z-10 transition-colors duration-300 ${
          recurringType === RecurringTypesEnum.SIXMONTH
            ? "text-white"
            : "text-sky-600"
        }`}>
        Six month
      </span>
    </div>
  );
};

export { RecurringTypeToggle };
